import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-top" }
const _hoisted_2 = { class: "containter topBar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "ps-10 pt-5 mb-0" }, "Rango de fechas", -1)
const _hoisted_4 = { class: "dateRange mb-4" }
const _hoisted_5 = { class: "containter-fluid" }
const _hoisted_6 = { class: "row mt-5" }
const _hoisted_7 = {
  class: "fw-bold titleAgency",
  style: {"font-size":"30px"}
}
const _hoisted_8 = {
  key: 0,
  class: "row mt-8"
}
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 bgFondo borderRadius" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_12 = { class: "row mt-5 mb-5" }
const _hoisted_13 = { class: "col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-end" }
const _hoisted_14 = { class: "spanStyle bgBlue" }
const _hoisted_15 = { class: "col-xs-6 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_16 = { class: "ulStyle" }
const _hoisted_17 = { class: "fw500" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Vehículos vendidos")
], -1)
const _hoisted_19 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_20 = { class: "row mt-5 mb-5" }
const _hoisted_21 = { class: "col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-end" }
const _hoisted_22 = { class: "spanStyle bgGreen" }
const _hoisted_23 = { class: "col-xs-6 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_24 = { class: "ulStyle" }
const _hoisted_25 = { class: "fw500" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Citas agendadas")
], -1)
const _hoisted_27 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_28 = { class: "row mt-5 mb-5" }
const _hoisted_29 = { class: "col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-end" }
const _hoisted_30 = { class: "spanStyle bgRed" }
const _hoisted_31 = { class: "col-xs-6 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_32 = { class: "ulStyle" }
const _hoisted_33 = { class: "fw500" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Avalúos realizados")
], -1)
const _hoisted_35 = {
  key: 1,
  class: "row mt-8"
}
const _hoisted_36 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 leftCol" }
const _hoisted_37 = { class: "buscados borderRadius" }
const _hoisted_38 = { class: "row mb13" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Vehículos más buscados")
], -1)
const _hoisted_40 = { class: "ulStyle" }
const _hoisted_41 = { class: "mt-2 mb-4" }
const _hoisted_42 = { class: "fw500" }
const _hoisted_43 = { class: "fs16 fw400" }
const _hoisted_44 = { class: "fs15" }
const _hoisted_45 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 leftRight" }
const _hoisted_46 = { class: "buscados borderRadius" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Marcas más buscadas")
], -1)
const _hoisted_49 = { class: "ulStyle" }
const _hoisted_50 = { class: "mt-2 mb-4 flowRoot" }
const _hoisted_51 = { class: "fw500 float-end fs16" }
const _hoisted_52 = { class: "fs16 fw400" }
const _hoisted_53 = { class: "fs15" }
const _hoisted_54 = { class: "row mt-8" }
const _hoisted_55 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 leftCol" }
const _hoisted_56 = { class: "buscados borderRadius pb-0" }
const _hoisted_57 = { class: "row mb13" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
  style: {"border-bottom":"1px solid #35353D"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Información de la agencia")
], -1)
const _hoisted_59 = { class: "col-xs-12 col-sm-12 col-md-2 col-lg-2 mt-4" }
const _hoisted_60 = { class: "ulStyle" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("li", { class: "mt-2 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw500" }, "Estado")
], -1)
const _hoisted_62 = { class: "fs16 fw400" }
const _hoisted_63 = { class: "col-xs-12 col-sm-12 col-md-3 col-lg-3 mt-4" }
const _hoisted_64 = { class: "ulStyle" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("li", { class: "mt-2 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw500" }, "Ciudad")
], -1)
const _hoisted_66 = { class: "fs16 fw400" }
const _hoisted_67 = { class: "col-xs-12 col-sm-12 col-md-3 col-lg-3 mt-4" }
const _hoisted_68 = { class: "ulStyle" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("li", { class: "mt-2 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw500" }, "Domicilio")
], -1)
const _hoisted_70 = { class: "fs16 fw400" }
const _hoisted_71 = { class: "col-xs-12 col-sm-12 col-md-2 col-lg-2 mt-4" }
const _hoisted_72 = { class: "ulStyle" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("li", { class: "mt-2 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw500" }, "Colonia")
], -1)
const _hoisted_74 = { class: "fs16 fw400" }
const _hoisted_75 = { class: "col-xs-12 col-sm-12 col-md-2 col-lg-2 mt-4" }
const _hoisted_76 = { class: "ulStyle" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("li", { class: "mt-2 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw500" }, "C.P.")
], -1)
const _hoisted_78 = { class: "fs16 fw400" }
const _hoisted_79 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 leftRight" }
const _hoisted_80 = { class: "buscados borderRadius pb-0" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
  style: {"border-bottom":"1px solid #35353D"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Leads y contacto")
], -1)
const _hoisted_83 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 ps-3 bcr" }
const _hoisted_84 = { class: "ulStyle" }
const _hoisted_85 = { class: "mt-3 mb-1" }
const _hoisted_86 = { style: {"font-size":"25px"} }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Clicks")
], -1)
const _hoisted_88 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 ps-3 bcr" }
const _hoisted_89 = { class: "ulStyle" }
const _hoisted_90 = { class: "mt-3 mb-1" }
const _hoisted_91 = { style: {"font-size":"25px"} }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Clicks")
], -1)
const _hoisted_93 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 ps-3" }
const _hoisted_94 = { class: "ulStyle mb-2" }
const _hoisted_95 = { class: "mt-3 mb-1" }
const _hoisted_96 = { style: {"font-size":"25px"} }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Leads", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("small", null, "Detalles", -1)
const _hoisted_99 = { class: "container-fluid px-0" }
const _hoisted_100 = { class: "row mt-6" }
const _hoisted_101 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 leftCol" }
const _hoisted_102 = { class: "short-div buscados pb-2 mb-9 borderRadius" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 ps-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Citas de avalúos")
], -1)
const _hoisted_105 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr ps-10 py-4" }
const _hoisted_106 = { class: "ulStyle" }
const _hoisted_107 = { class: "mt-2 mb-2" }
const _hoisted_108 = { class: "fw500 fs30" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400" }, "Total de citas")
], -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_111 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr ps-10 py-4" }
const _hoisted_112 = { class: "ulStyle" }
const _hoisted_113 = { class: "mt-2 mb-2" }
const _hoisted_114 = { class: "fw500 fs30" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Pendientes")
], -1)
const _hoisted_116 = { class: "fs13" }
const _hoisted_117 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct ps-10 py-4" }
const _hoisted_118 = { class: "ulStyle" }
const _hoisted_119 = { class: "mt-2 mb-2" }
const _hoisted_120 = { class: "fw500 fs30" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Canceladas")
], -1)
const _hoisted_122 = { class: "fs13" }
const _hoisted_123 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr ps-10 py-4" }
const _hoisted_124 = { class: "ulStyle" }
const _hoisted_125 = { class: "mt-2 mb-2" }
const _hoisted_126 = { class: "fw500 fs30" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Atendidas")
], -1)
const _hoisted_128 = { class: "fs13" }
const _hoisted_129 = { class: "col-xs-12 col-sm-12 col-md-8 col-lg-8 bct ps-10 py-4" }
const _hoisted_130 = { class: "ulStyle" }
const _hoisted_131 = { class: "mt-2 mb-2" }
const _hoisted_132 = { class: "fw500 fs30" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Efectivas")
], -1)
const _hoisted_134 = { class: "fs13" }
const _hoisted_135 = { class: "short-div buscados pb-0 borderRadius" }
const _hoisted_136 = { class: "row" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 ps-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Avalúos")
], -1)
const _hoisted_138 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-6 bct bcr ps-10 py-4" }
const _hoisted_139 = { class: "ulStyle" }
const _hoisted_140 = { class: "mt-2 mb-2" }
const _hoisted_141 = { class: "fw500 fs30" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400" }, "Totales")
], -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_144 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-6 bct ps-10 py-4" }
const _hoisted_145 = { class: "ulStyle" }
const _hoisted_146 = { class: "mt-2 mb-2" }
const _hoisted_147 = { class: "fw500 fs30" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Comprados")
], -1)
const _hoisted_149 = { class: "fs13" }
const _hoisted_150 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bcr bct ps-10 py-4" }
const _hoisted_151 = { class: "ulStyle" }
const _hoisted_152 = { class: "mt-2 mb-2" }
const _hoisted_153 = { class: "fw500 fs30" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Cancelados")
], -1)
const _hoisted_155 = { class: "fs13" }
const _hoisted_156 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bcr bct ps-10 py-4" }
const _hoisted_157 = { class: "ulStyle" }
const _hoisted_158 = { class: "mt-2 mb-2" }
const _hoisted_159 = { class: "fw500 fs30" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Documentación")
], -1)
const _hoisted_161 = { class: "fs13" }
const _hoisted_162 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct ps-10 py-4" }
const _hoisted_163 = { class: "ulStyle" }
const _hoisted_164 = { class: "mt-2 mb-2" }
const _hoisted_165 = { class: "fw500 fs30" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "En negociación")
], -1)
const _hoisted_167 = { class: "fs13" }
const _hoisted_168 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 leftRight" }
const _hoisted_169 = { class: "buscados pb-0 borderRadius" }
const _hoisted_170 = { class: "row" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 ps-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Vehículos")
], -1)
const _hoisted_172 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 bct ps-10 py-6" }
const _hoisted_173 = { class: "ulStyle" }
const _hoisted_174 = { class: "mt-2 mb-2" }
const _hoisted_175 = { class: "fw500 fs30" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600" }, "Activos")
], -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_178 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 bct ps-10 py-5" }
const _hoisted_179 = { class: "ulStyle" }
const _hoisted_180 = { class: "mt-2 mb-2" }
const _hoisted_181 = { class: "fw500 fs30" }
const _hoisted_182 = { class: "fs16 fw600" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_184 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 bct ps-10 py-5" }
const _hoisted_185 = { class: "ulStyle" }
const _hoisted_186 = { class: "mt-2 mb-2" }
const _hoisted_187 = { class: "fw500 fs30" }
const _hoisted_188 = { class: "fs16 fw600" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_190 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 bct ps-10 py-5" }
const _hoisted_191 = { class: "ulStyle" }
const _hoisted_192 = { class: "mt-2 mb-2" }
const _hoisted_193 = { class: "fw500 fs30" }
const _hoisted_194 = { class: "fs16 fw600" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_196 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 bct ps-10 py-6" }
const _hoisted_197 = { class: "ulStyle" }
const _hoisted_198 = { class: "mt-2 mb-2" }
const _hoisted_199 = { class: "fw500 fs30" }
const _hoisted_200 = { class: "fs16 fw600" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_202 = { class: "container-fluid px-0" }
const _hoisted_203 = { class: "row mt-8" }
const _hoisted_204 = { class: "buscados pb-0 borderRadius" }
const _hoisted_205 = { class: "row" }
const _hoisted_206 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 ps-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Citas de venta")
], -1)
const _hoisted_207 = { class: "col-xs-12 col-sm-3 col-md-3 col-lg-3 bct ps-10 py-6 pb-0 bcr" }
const _hoisted_208 = { class: "ulStyle" }
const _hoisted_209 = { class: "mt-2 mb-2" }
const _hoisted_210 = { class: "fw500 fs30" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mb-0" }, "Total de citas")
], -1)
const _hoisted_212 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_213 = { class: "col-xs-12 col-sm-3 col-md-3 col-lg-3 bct ps-10 py-6 pb-0 bcr" }
const _hoisted_214 = { class: "ulStyle" }
const _hoisted_215 = { class: "mt-2 mb-2" }
const _hoisted_216 = { class: "fw500 fs30" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mb-0" }, "Pendientes")
], -1)
const _hoisted_218 = { class: "col-xs-12 col-sm-3 col-md-3 col-lg-3 bct ps-10 py-6 pb-0 bcr" }
const _hoisted_219 = { class: "ulStyle" }
const _hoisted_220 = { class: "mt-2 mb-2" }
const _hoisted_221 = { class: "fw500 fs30" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mb-0" }, "Cancelados")
], -1)
const _hoisted_223 = { class: "col-xs-12 col-sm-3 col-md-3 col-lg-3 bct ps-10 py-6 pb-0" }
const _hoisted_224 = { class: "ulStyle" }
const _hoisted_225 = { class: "mt-2 mb-2" }
const _hoisted_226 = { class: "fw500 fs30" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mb-0" }, "Atendidas")
], -1)
const _hoisted_228 = { class: "container-fluid px-0" }
const _hoisted_229 = { class: "row mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRange = _resolveComponent("DateRange")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Vehicles = _resolveComponent("Vehicles")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DateRange, {
          onGetDates: _ctx.getDates,
          range: true,
          placeholder: _ctx.placesHolderDates,
          class: _normalizeClass(["ps-10", 'dashboard']),
          selectText: 'Aplicar',
          cancelText: 'Cancelar'
        }, null, 8, ["onGetDates", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, [
          _createVNode(_component_inline_svg, {
            onClick: _ctx.returnGo,
            class: "pointer",
            src: "media/icons/iconsax/arrow-left.svg"
          }, null, 8, ["onClick"]),
          _createTextVNode("  " + _toDisplayString(_ctx.dashboardData.agencia_info.nombre), 1)
        ])
      ]),
      (_ctx.tipoRol == 'Múltiples agencias')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, {
                          height: "40",
                          width: "40",
                          src: "media/icons/iconsax/car.svg"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("ul", _hoisted_16, [
                        _createElementVNode("li", null, [
                          _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.dashboardData.vehiculos_vendidos), 1)
                        ]),
                        _hoisted_18,
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'vehicles-filters', params: {filter:4} },
                            class: "routerUnder"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Ver vehículos ")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, [
                        _createVNode(_component_inline_svg, {
                          height: "40",
                          width: "40",
                          src: "media/icons/iconsax/calendar.svg"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("ul", _hoisted_24, [
                        _createElementVNode("li", null, [
                          _createElementVNode("h1", _hoisted_25, _toDisplayString(_ctx.dashboardData.citas_agendadas_en_sitio), 1)
                        ]),
                        _hoisted_26,
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: "/calendario",
                            class: "routerUnder"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Ver citas de agencias ")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, [
                        _createVNode(_component_inline_svg, {
                          height: "40",
                          width: "40",
                          src: "media/icons/iconsax/receipt-item.svg"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("ul", _hoisted_32, [
                        _createElementVNode("li", null, [
                          _createElementVNode("h1", _hoisted_33, _toDisplayString(_ctx.dashboardData.avaluos_en_agencia), 1)
                        ]),
                        _hoisted_34,
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: "/appraisals",
                            class: "routerUnder"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Ver avalúos de agencias ")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tipoRol == 'Múltiples agencias')
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardData.modelos_populares, (modelo) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-xs-12 col-sm-12 col-md-4 col-lg-4",
                      key: modelo.marca
                    }, [
                      _createElementVNode("ul", _hoisted_40, [
                        _createElementVNode("li", _hoisted_41, [
                          _createElementVNode("h1", _hoisted_42, "#" + _toDisplayString(modelo.rating), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("p", _hoisted_43, _toDisplayString(modelo.marca), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("p", _hoisted_44, _toDisplayString(modelo.total) + " búsquedas", 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardData.marcas_populares, (marca) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 pe-10",
                      key: marca.marca
                    }, [
                      _createElementVNode("ul", _hoisted_49, [
                        _createElementVNode("li", _hoisted_50, [
                          _createVNode(_component_inline_svg, {
                            src: "{{ marca.icon }}",
                            height: "40",
                            width: "40",
                            class: "float-start"
                          }),
                          _createElementVNode("p", _hoisted_51, "#" + _toDisplayString(marca.rating), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("p", _hoisted_52, _toDisplayString(marca.marca), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("p", _hoisted_53, _toDisplayString(marca.total) + " búsquedas", 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("ul", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.dashboardData.agencia_info.estado), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("ul", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.dashboardData.agencia_info.ciudad), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("ul", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.dashboardData.agencia_info.domicilio), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("ul", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_74, _toDisplayString(_ctx.dashboardData.agencia_info.colonia), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("ul", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.dashboardData.agencia_info.cp), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("ul", _hoisted_84, [
                  _createElementVNode("li", _hoisted_85, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Whatsapp.svg" }),
                    _createTextVNode(" "),
                    _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.dashboardData.leads_y_contacto.wasap_clicks), 1)
                  ]),
                  _hoisted_87
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("ul", _hoisted_89, [
                  _createElementVNode("li", _hoisted_90, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Teléfono.svg" }),
                    _createTextVNode(" "),
                    _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.dashboardData.leads_y_contacto.phone_clicks), 1)
                  ]),
                  _hoisted_92
                ])
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("ul", _hoisted_94, [
                  _createElementVNode("li", _hoisted_95, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Personalcard-LEAD.svg" }),
                    _createTextVNode(" "),
                    _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.dashboardData.leads_y_contacto.leads), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_97,
                    _createVNode(_component_router_link, {
                      to: {name:'leads-filters', params: {tipo: 'Contacto', agencia: _ctx.idAgencie  }} 
                    }, {
                      default: _withCtx(() => [
                        _hoisted_98
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              _hoisted_104,
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("ul", _hoisted_106, [
                  _createElementVNode("li", _hoisted_107, [
                    _createElementVNode("h1", _hoisted_108, _toDisplayString(_ctx.dashboardData.citas_avaluos.total), 1)
                  ]),
                  _hoisted_109,
                  _hoisted_110
                ])
              ]),
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("ul", _hoisted_112, [
                  _createElementVNode("li", _hoisted_113, [
                    _createElementVNode("h1", _hoisted_114, _toDisplayString(_ctx.dashboardData.citas_avaluos.pendiente), 1)
                  ]),
                  _hoisted_115,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_116, [
                      _createVNode(_component_router_link, {
                        to: _ctx.tipoRol == 'Múltiples agencias' ? {name: 'Calendario'} : {name:'citas-filters', params: {tipo: 1, status: 1, agencia: _ctx.idAgencie  }} ,
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_117, [
                _createElementVNode("ul", _hoisted_118, [
                  _createElementVNode("li", _hoisted_119, [
                    _createElementVNode("h1", _hoisted_120, _toDisplayString(_ctx.dashboardData.citas_avaluos.cancelada), 1)
                  ]),
                  _hoisted_121,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_122, [
                      _createVNode(_component_router_link, {
                        to: _ctx.tipoRol == 'Múltiples agencias' ? {name: 'Calendario'} : {name:'citas-filters', params: {tipo: 1, status: 3, agencia: _ctx.idAgencie  }} ,
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_123, [
                _createElementVNode("ul", _hoisted_124, [
                  _createElementVNode("li", _hoisted_125, [
                    _createElementVNode("h1", _hoisted_126, _toDisplayString(_ctx.dashboardData.citas_avaluos.atendida), 1)
                  ]),
                  _hoisted_127,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_128, [
                      _createVNode(_component_router_link, {
                        to: _ctx.tipoRol == 'Múltiples agencias' ? {name: 'Calendario'} : {name:'citas-filters', params: {tipo: 1, status: 2, agencia: _ctx.idAgencie  }} ,
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("ul", _hoisted_130, [
                  _createElementVNode("li", _hoisted_131, [
                    _createElementVNode("h1", _hoisted_132, _toDisplayString(_ctx.dashboardData.citas_avaluos.efectivas), 1)
                  ]),
                  _hoisted_133,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_134, [
                      _createVNode(_component_router_link, {
                        to: _ctx.tipoRol == 'Múltiples agencias' ? {name: 'Calendario'} : {name:'citas-filters', params: {tipo: 1, status: 0, agencia: _ctx.idAgencie  }} ,
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_135, [
            _createElementVNode("div", _hoisted_136, [
              _hoisted_137,
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("ul", _hoisted_139, [
                  _createElementVNode("li", _hoisted_140, [
                    _createElementVNode("h1", _hoisted_141, _toDisplayString(_ctx.dashboardData.avaluos.total), 1)
                  ]),
                  _hoisted_142,
                  _hoisted_143
                ])
              ]),
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("ul", _hoisted_145, [
                  _createElementVNode("li", _hoisted_146, [
                    _createElementVNode("h1", _hoisted_147, _toDisplayString(_ctx.dashboardData.avaluos.comprados), 1)
                  ]),
                  _hoisted_148,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_149, [
                      _createVNode(_component_router_link, {
                        to: { name: 'appraisals-filters', params: {filter:3} },
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("ul", _hoisted_151, [
                  _createElementVNode("li", _hoisted_152, [
                    _createElementVNode("h1", _hoisted_153, _toDisplayString(_ctx.dashboardData.avaluos.cancelados), 1)
                  ]),
                  _hoisted_154,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_155, [
                      _createVNode(_component_router_link, {
                        to: { name: 'appraisals-filters', params: {filter:4} },
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_156, [
                _createElementVNode("ul", _hoisted_157, [
                  _createElementVNode("li", _hoisted_158, [
                    _createElementVNode("h1", _hoisted_159, _toDisplayString(_ctx.dashboardData.avaluos.en_documentacion), 1)
                  ]),
                  _hoisted_160,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_161, [
                      _createVNode(_component_router_link, {
                        to: { name: 'appraisals-filters', params: {filter:2} },
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_162, [
                _createElementVNode("ul", _hoisted_163, [
                  _createElementVNode("li", _hoisted_164, [
                    _createElementVNode("h1", _hoisted_165, _toDisplayString(_ctx.dashboardData.avaluos.en_negociacion), 1)
                  ]),
                  _hoisted_166,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_167, [
                      _createVNode(_component_router_link, {
                        to: { name: 'appraisals-filters', params: {filter:1} },
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_168, [
          _createElementVNode("div", _hoisted_169, [
            _createElementVNode("div", _hoisted_170, [
              _hoisted_171,
              _createElementVNode("div", _hoisted_172, [
                _createElementVNode("ul", _hoisted_173, [
                  _createElementVNode("li", _hoisted_174, [
                    _createElementVNode("h1", _hoisted_175, _toDisplayString(_ctx.dashboardData.vehiculos_de_agencia.activos), 1)
                  ]),
                  _hoisted_176,
                  _hoisted_177
                ])
              ]),
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("ul", _hoisted_179, [
                  _createElementVNode("li", _hoisted_180, [
                    _createElementVNode("h1", _hoisted_181, _toDisplayString(_ctx.dashboardData.vehiculos_de_agencia.vendidos), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_182, [
                      _createTextVNode("Vendidos  "),
                      _createElementVNode("small", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'vehicles-filters', params: {filter:4} },
                          class: "subrayado"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Detalles")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _hoisted_183
                ])
              ]),
              _createElementVNode("div", _hoisted_184, [
                _createElementVNode("ul", _hoisted_185, [
                  _createElementVNode("li", _hoisted_186, [
                    _createElementVNode("h1", _hoisted_187, _toDisplayString(_ctx.dashboardData.vehiculos_de_agencia.apartados), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_188, [
                      _createTextVNode("Apartados  "),
                      _createElementVNode("small", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'vehicles-filters', params: {filter:3} },
                          class: "subrayado"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Detalles")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _hoisted_189
                ])
              ]),
              _createElementVNode("div", _hoisted_190, [
                _createElementVNode("ul", _hoisted_191, [
                  _createElementVNode("li", _hoisted_192, [
                    _createElementVNode("h1", _hoisted_193, _toDisplayString(_ctx.dashboardData.vehiculos_de_agencia.vistos), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_194, [
                      _createTextVNode("Vehículos vistos  "),
                      _createElementVNode("small", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'vehicles-filters', params: {filter:7, agency: _ctx.idAgencie} },
                          class: "subrayado"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Detalles")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  ]),
                  _hoisted_195
                ])
              ]),
              _createElementVNode("div", _hoisted_196, [
                _createElementVNode("ul", _hoisted_197, [
                  _createElementVNode("li", _hoisted_198, [
                    _createElementVNode("h1", _hoisted_199, _toDisplayString(_ctx.dashboardData.vehiculos_de_agencia.proximamente), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_200, [
                      _createTextVNode("Próximamente  "),
                      _createElementVNode("small", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'vehicles-filters', params: {filter:6} },
                          class: "subrayado"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Detalles")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _hoisted_201
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_202, [
      _createElementVNode("div", _hoisted_203, [
        _createElementVNode("div", _hoisted_204, [
          _createElementVNode("div", _hoisted_205, [
            _hoisted_206,
            _createElementVNode("div", _hoisted_207, [
              _createElementVNode("ul", _hoisted_208, [
                _createElementVNode("li", _hoisted_209, [
                  _createElementVNode("h1", _hoisted_210, _toDisplayString(_ctx.dashboardData.citas_venta.total), 1)
                ]),
                _hoisted_211,
                _hoisted_212
              ])
            ]),
            _createElementVNode("div", _hoisted_213, [
              _createElementVNode("ul", _hoisted_214, [
                _createElementVNode("li", _hoisted_215, [
                  _createElementVNode("h1", _hoisted_216, _toDisplayString(_ctx.dashboardData.citas_venta.pendiente), 1)
                ]),
                _hoisted_217,
                _createElementVNode("li", null, [
                  _createElementVNode("small", null, [
                    _createVNode(_component_router_link, {
                      to: _ctx.tipoRol == 'Múltiples agencias' ? {name: 'Calendario'} : {name:'citas-filters', params: {tipo: 2, status: 1, agencia: _ctx.idAgencie  }} ,
                      class: "subrayado"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Detalles")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_218, [
              _createElementVNode("ul", _hoisted_219, [
                _createElementVNode("li", _hoisted_220, [
                  _createElementVNode("h1", _hoisted_221, _toDisplayString(_ctx.dashboardData.citas_venta.cancelada), 1)
                ]),
                _hoisted_222,
                _createElementVNode("li", null, [
                  _createElementVNode("small", null, [
                    _createVNode(_component_router_link, {
                      to: _ctx.tipoRol == 'Múltiples agencias' ? {name: 'Calendario'} : {name:'citas-filters', params: {tipo: 2, status: 3, agencia: _ctx.idAgencie  }} ,
                      class: "subrayado"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Detalles")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_223, [
              _createElementVNode("ul", _hoisted_224, [
                _createElementVNode("li", _hoisted_225, [
                  _createElementVNode("h1", _hoisted_226, _toDisplayString(_ctx.dashboardData.citas_venta.atendida), 1)
                ]),
                _hoisted_227,
                _createElementVNode("li", null, [
                  _createElementVNode("small", null, [
                    _createVNode(_component_router_link, {
                      to: _ctx.tipoRol == 'Múltiples agencias' ? {name: 'Calendario'} : {name:'citas-filters', params: {tipo: 2, status: 2, agencia: _ctx.idAgencie  }} ,
                      class: "subrayado"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Detalles")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_228, [
      _createElementVNode("div", _hoisted_229, [
        _createVNode(_component_Vehicles, {
          agencyId: _ctx.idAgencie,
          showStatics: false
        }, null, 8, ["agencyId"])
      ])
    ])
  ]))
}